module.exports = __webpack_public_path__ + "static/media/loading.5105bf0c.gif";